export const isSystemConnected = sys => {
  const config = sys?.connect_config?.[0];
  return Boolean(config?.is_authenticated && config?.is_active);
};

export const isXeroConnected = externalSystems =>
  (externalSystems || []).some(sys => sys.code === "xero" && isSystemConnected(sys));
